export const mockProps = {
  'id': 'a1ae137d-90ed-46b9-b51b-d25804533c80',
  'type': 'homepage',
  'moduleName': 'UltamateRewardsOffers',
  'title': 'Ulta Beauty Rewards™ - Help Changes',
  'subTitle': 'You have %1 bonus offers',
  'titleText': {
    'moduleName': 'TextLite',
    '_meta': {
      'schema': 'https://qa.ulta.com/cms/schema/TextLite.json'
    }
  },
  'timerMeta': {
    'comingSoonLabel': 'Coming soon',
    'extendedLabel': 'Extended until %1 CT',
    'hoursLabel': '%1 | %2 CT',
    'todayOnlyLabel': 'Today Only | Ends %1 CT',
    'todayAndTomorrowLabel': 'Today & Tomorrow',
    'endsTomorrowLabel': 'Ends Tomorrow at %1 CT',
    'endsTodayLabel': 'Ends Today | %1 CT',
    'endsLabel': 'Ends %1',
    'endsInLabel': 'Ends in %1',
    'offerEndedLabel': 'Offer has Ended',
    'spacerValue': '00',
    'moduleName': 'TimerMeta',
    '_meta': {
      'schema': 'https://qa.ulta.com/cms/schema/TimerMeta.json',
      'name': 'Timer_Meta',
      'deliveryId': '7f32df87-e896-4a04-97ed-68c79bf1338e'
    }
  },
  'viewAllOffersAction': null,
  'nextClickAction': {
    'moduleName': 'Action',
    'url': null,
    'navigationType': null,
    'label': null,
    'graphql': null,
    'pop': false,
    'anchorId': null,
    'dataCaptureData': {
      'category': 'Interaction',
      'eventName': 'rail_interaction',
      'clientEvent': 'Click',
      'moduleName': 'DataCaptureEvent',
      'dataLayer': {
        'Tealium': {
          'action_label': 'next',
          'component_type': 'ultamaterewardsoffers',
          'component_title': 'ulta beauty rewards™ - help changes',
          'item_eyebrow': [
            'a program for members to earn on every shopping'
          ],
          'item_tag': [
            'sign in or join now'
          ],
          'tealium_event': 'rail_interaction'
        }
      },
      'unresolvedData': []
    },
    'content': null,
    'clientActionType': null,
    'customHeaders': [],
    'clientActionParams': null,
    'method': 'GET',
    'accessibility': null
  },
  'previousClickAction': {
    'moduleName': 'Action',
    'url': null,
    'navigationType': null,
    'label': null,
    'graphql': null,
    'pop': false,
    'anchorId': null,
    'dataCaptureData': {
      'category': 'Interaction',
      'eventName': 'rail_interaction',
      'clientEvent': 'Click',
      'moduleName': 'DataCaptureEvent',
      'dataLayer': {
        'Tealium': {
          'action_label': 'previous',
          'component_type': 'ultamaterewardsoffers',
          'component_title': 'ulta beauty rewards™ - help changes',
          'item_eyebrow': '',
          'item_tag': '',
          'tealium_event': 'rail_interaction'
        }
      },
      'unresolvedData': []
    },
    'content': null,
    'clientActionType': null,
    'customHeaders': [],
    'clientActionParams': null,
    'method': 'GET',
    'accessibility': null
  },
  'vertical': false,
  'offersTabDataCaptureAction': null,
  'messagesTabDataCaptureAction': null,
  'spacerValue': '06',
  'variantType': 'mediumDealCard',
  'dataCapture': {
    'category': 'Interaction',
    'eventName': 'component_impression',
    'clientEvent': 'Viewport',
    'moduleName': 'DataCaptureEvent',
    'dataLayer': {
      'Tealium': {
        'component_type': 'ultamaterewardsoffers',
        'component_title': 'ulta beauty rewards™ - help changes',
        'tealium_event': 'component_impression'
      }
    },
    'unresolvedData': []
  },
  'meta': null,
  'pointsLabel': null,
  'pointsValueLabel': null,
  'loyaltyTier': null,
  'offers': [
    {
      'image': {
        'isCaptionsEnabled': true,
        'action': null,
        'moduleName': 'UltaAsset',
        'isInlineVideo': false,
        'isAutoPlay': false,
        '_meta': {
          'schema': 'http://bigcontent.io/cms/schema/v1/core#/definitions/image-link'
        },
        'imageUrl': 'https://media.ulta.com/i/ulta/beauty-services_20off-promo_april2021_article',
        'id': 'f4fe2f4e-3b08-4082-be2c-3c0d293a2b1f',
        'name': 'beauty-services_20off-promo_april2021_article',
        'endpoint': 'ulta',
        'defaultHost': 'media.ulta.com',
        'metaData': {
          'mediaType': 'image',
          'imageTemplate': 'None',
          'isImage': true,
          'format': 'PNG',
          'width': 852,
          'height': 856,
          'aspectRatio': {
            'w': '1.00',
            'h': 1
          }
        }
      },
      'tag': 'sign in or join now',
      'eyebrow': 'A program for members to earn on every shopping',
      'headline': 'Ulta Beauty Rewards™ - Non signed in',
      'description': 'More benefits for loyalty members',
      'actionGroup': {
        'action1': {
          'label': 'SIGN IN',
          'url': null,
          'graphql': 'query Page( $stagingHost: String, $previewOptions: JSON, $moduleParams: JSON , $url: JSON) {\n    Page: Page( stagingHost:$stagingHost, previewOptions:$previewOptions, moduleParams:$moduleParams , url: $url, contentId: "2c44d6e2-3b8f-4033-a55d-1bfe210d3498") {\n      content\n      customResponseAttributes\n      meta\n    }\n  }',
          'pop': false,
          'navigationType': 'flyout',
          'anchorId': null,
          'dataCaptureData': {
            'category': 'Interaction',
            'eventName': 'select_content',
            'clientEvent': 'Click',
            'moduleName': 'DataCaptureEvent',
            'dataLayer': {
              'Tealium': {
                'component_click_metric': '1',
                'action_type': 'link',
                'action_label': 'view offer',
                'component_type': 'ultamaterewardsoffers',
                'component_title': 'ulta beauty rewards™ - help changes',
                'item_detail': [
                  'ulta beauty rewards™ - non signed in'
                ],
                'item_index': [
                  '1'
                ],
                'item_eyebrow': [
                  'a program for members to earn on every shopping'
                ],
                'item_tag': [
                  'sign in or join now'
                ],
                'tealium_event': 'select_content'
              }
            },
            'unresolvedData': []
          },
          'content': null,
          'clientActionType': null,
          'customHeaders': [
            {
              'key': 'X-ULTA-GRAPH-MODULE-NAME',
              'value': 'SignInOverlay'
            },
            {
              'key': 'X-ULTA-GRAPH-TYPE',
              'value': 'query'
            },
            {
              'key': 'X-ULTA-GRAPH-SUB-TYPE',
              'value': 'page'
            },
            {
              'key': 'X-ULTA-GRAPH-TYPE',
              'value': 'query'
            },
            {
              'key': 'X-ULTA-GRAPH-SUB-TYPE',
              'value': 'page'
            }
          ],
          'clientActionParams': null,
          'method': 'GET',
          'accessibility': null
        },
        'action2': {
          'label': 'Join Now',
          'url': 'https://local.ulta.com:8080/qa/rewards/all?User-Agent=gomez',
          'graphql': null,
          'pop': false,
          'navigationType': 'redirect',
          'anchorId': null,
          'dataCaptureData': {
            'category': 'Interaction',
            'eventName': 'select_content',
            'clientEvent': 'Click',
            'moduleName': 'DataCaptureEvent',
            'dataLayer': {
              'Tealium': {
                'component_click_metric': '1',
                'action_type': 'link',
                'action_label': 'shop now',
                'component_type': 'ultamaterewardsoffers',
                'component_title': 'ulta beauty rewards™ - help changes',
                'item_detail': [
                  'ulta beauty rewards™ - non signed in'
                ],
                'item_index': [
                  '1'
                ],
                'item_eyebrow': [
                  'a program for members to earn on every shopping'
                ],
                'item_tag': [
                  'sign in or join now'
                ],
                'tealium_event': 'select_content'
              }
            },
            'unresolvedData': []
          },
          'content': null,
          'clientActionType': null,
          'customHeaders': [],
          'clientActionParams': null,
          'method': 'GET',
          'accessibility': null
        },
        'action1Style': 'primary',
        'action2Style': 'link',
        'spacerValue': '04',
        'moduleName': 'ActionGroup',
        '_meta': {
          'schema': 'https://qa.ulta.com/cms/schema/ActionGroup.json',
          'name': 'Action Group 1 - Ultamate offers',
          'deliveryId': 'a5269cc8-c8ab-4d14-93c3-e61fd10dd78d'
        }
      },
      'moduleName': 'LargeDeal',
      '_meta': {
        'schema': 'https://qa.ulta.com/cms/schema/LargeDeal.json',
        'name': 'Large Deal - Ultamate rewards non signed in',
        'deliveryId': 'e97caf25-2ed6-428d-9e1e-fcfbbdd8bab7'
      },
      'isOfferActivated': false,
      'offerId': null,
      'offerMasterId': null,
      'activateAction': null,
      'activatedLabel': null
    }, {
      'image': {
        'isCaptionsEnabled': true,
        'action': null,
        'moduleName': 'UltaAsset',
        'isInlineVideo': false,
        'isAutoPlay': false,
        '_meta': {
          'schema': 'http://bigcontent.io/cms/schema/v1/core#/definitions/image-link'
        },
        'imageUrl': 'https://media.ulta.com/i/ulta/beauty-services_20off-promo_april2021_article',
        'id': 'f4fe2f4e-3b08-4082-be2c-3c0d293a2b1f',
        'name': 'beauty-services_20off-promo_april2021_article',
        'endpoint': 'ulta',
        'defaultHost': 'media.ulta.com',
        'metaData': {
          'mediaType': 'image',
          'imageTemplate': 'None',
          'isImage': true,
          'format': 'PNG',
          'width': 852,
          'height': 856,
          'aspectRatio': {
            'w': '1.00',
            'h': 1
          }
        }
      },
      'tag': 'sign in or join now',
      'eyebrow': 'A program for members to earn on every shopping',
      'headline': 'Ulta Beauty Rewards™ - Non signed in',
      'description': 'Earn 5X points on participating youth booster and glow getting products! If copy runs long, it should truncate at 3. BaBylissPRO Nano Titanium Spring Curling Iron combines Sol Gel technology with a titanium/ceramic barrel to transfer heat and deliver smoothing ions.',
      'actionGroup': {
        'action1': {
          'label': 'SIGN IN',
          'url': null,
          'graphql': 'query Page( $stagingHost: String, $previewOptions: JSON, $moduleParams: JSON , $url: JSON) {\n    Page: Page( stagingHost:$stagingHost, previewOptions:$previewOptions, moduleParams:$moduleParams , url: $url, contentId: "2c44d6e2-3b8f-4033-a55d-1bfe210d3498") {\n      content\n      customResponseAttributes\n      meta\n    }\n  }',
          'pop': false,
          'navigationType': 'flyout',
          'anchorId': null,
          'dataCaptureData': {
            'category': 'Interaction',
            'eventName': 'select_content',
            'clientEvent': 'Click',
            'moduleName': 'DataCaptureEvent',
            'dataLayer': {
              'Tealium': {
                'component_click_metric': '1',
                'action_type': 'link',
                'action_label': 'view offer',
                'component_type': 'ultamaterewardsoffers',
                'component_title': 'ulta beauty rewards™ - help changes',
                'item_detail': [
                  'ulta beauty rewards™ - non signed in'
                ],
                'item_index': [
                  '1'
                ],
                'item_eyebrow': [
                  'a program for members to earn on every shopping'
                ],
                'item_tag': [
                  'sign in or join now'
                ],
                'tealium_event': 'select_content'
              }
            },
            'unresolvedData': []
          },
          'content': null,
          'clientActionType': null,
          'customHeaders': [
            {
              'key': 'X-ULTA-GRAPH-MODULE-NAME',
              'value': 'SignInOverlay'
            },
            {
              'key': 'X-ULTA-GRAPH-TYPE',
              'value': 'query'
            },
            {
              'key': 'X-ULTA-GRAPH-SUB-TYPE',
              'value': 'page'
            },
            {
              'key': 'X-ULTA-GRAPH-TYPE',
              'value': 'query'
            },
            {
              'key': 'X-ULTA-GRAPH-SUB-TYPE',
              'value': 'page'
            }
          ],
          'clientActionParams': null,
          'method': 'GET',
          'accessibility': null
        },
        'action2': {
          'label': 'Join Now',
          'url': 'https://local.ulta.com:8080/qa/rewards/all?User-Agent=gomez',
          'graphql': null,
          'pop': false,
          'navigationType': 'redirect',
          'anchorId': null,
          'dataCaptureData': {
            'category': 'Interaction',
            'eventName': 'select_content',
            'clientEvent': 'Click',
            'moduleName': 'DataCaptureEvent',
            'dataLayer': {
              'Tealium': {
                'component_click_metric': '1',
                'action_type': 'link',
                'action_label': 'shop now',
                'component_type': 'ultamaterewardsoffers',
                'component_title': 'ulta beauty rewards™ - help changes',
                'item_detail': [
                  'ulta beauty rewards™ - non signed in'
                ],
                'item_index': [
                  '1'
                ],
                'item_eyebrow': [
                  'a program for members to earn on every shopping'
                ],
                'item_tag': [
                  'sign in or join now'
                ],
                'tealium_event': 'select_content'
              }
            },
            'unresolvedData': []
          },
          'content': null,
          'clientActionType': null,
          'customHeaders': [],
          'clientActionParams': null,
          'method': 'GET',
          'accessibility': null
        },
        'action1Style': 'primary',
        'action2Style': 'link',
        'spacerValue': '04',
        'moduleName': 'ActionGroup',
        '_meta': {
          'schema': 'https://qa.ulta.com/cms/schema/ActionGroup.json',
          'name': 'Action Group 1 - Ultamate offers',
          'deliveryId': 'a5269cc8-c8ab-4d14-93c3-e61fd10dd78d'
        }
      },
      'moduleName': 'LargeDeal',
      '_meta': {
        'schema': 'https://qa.ulta.com/cms/schema/LargeDeal.json',
        'name': 'Large Deal - Ultamate rewards non signed in',
        'deliveryId': 'e97caf25-2ed6-428d-9e1e-fcfbbdd8bab7'
      },
      'isOfferActivated': false,
      'offerId': null,
      'offerMasterId': null,
      'activateAction': null,
      'activatedLabel': null
    }, {
      'image': {
        'isCaptionsEnabled': true,
        'action': null,
        'moduleName': 'UltaAsset',
        'isInlineVideo': false,
        'isAutoPlay': false,
        '_meta': {
          'schema': 'http://bigcontent.io/cms/schema/v1/core#/definitions/image-link'
        },
        'imageUrl': 'https://media.ulta.com/i/ulta/beauty-services_20off-promo_april2021_article',
        'id': 'f4fe2f4e-3b08-4082-be2c-3c0d293a2b1f',
        'name': 'beauty-services_20off-promo_april2021_article',
        'endpoint': 'ulta',
        'defaultHost': 'media.ulta.com',
        'metaData': {
          'mediaType': 'image',
          'imageTemplate': 'None',
          'isImage': true,
          'format': 'PNG',
          'width': 852,
          'height': 856,
          'aspectRatio': {
            'w': '1.00',
            'h': 1
          }
        }
      },
      'tag': 'sign in or join now',
      'eyebrow': 'A program for members to earn on every shopping',
      'headline': 'Ulta Beauty Rewards™ - Non signed in',
      'description': 'Earn 5X points on participating youth booster and glow getting products! If copy runs long, it should truncate at 3. BaBylissPRO Nano Titanium Spring Curling Iron combines Sol Gel technology with a titanium/ceramic barrel to transfer heat and deliver smoothing ions.',
      'actionGroup': {
        'action1': {
          'label': 'SIGN IN',
          'url': null,
          'graphql': 'query Page( $stagingHost: String, $previewOptions: JSON, $moduleParams: JSON , $url: JSON) {\n    Page: Page( stagingHost:$stagingHost, previewOptions:$previewOptions, moduleParams:$moduleParams , url: $url, contentId: "2c44d6e2-3b8f-4033-a55d-1bfe210d3498") {\n      content\n      customResponseAttributes\n      meta\n    }\n  }',
          'pop': false,
          'navigationType': 'flyout',
          'anchorId': null,
          'dataCaptureData': {
            'category': 'Interaction',
            'eventName': 'select_content',
            'clientEvent': 'Click',
            'moduleName': 'DataCaptureEvent',
            'dataLayer': {
              'Tealium': {
                'component_click_metric': '1',
                'action_type': 'link',
                'action_label': 'view offer',
                'component_type': 'ultamaterewardsoffers',
                'component_title': 'ulta beauty rewards™ - help changes',
                'item_detail': [
                  'ulta beauty rewards™ - non signed in'
                ],
                'item_index': [
                  '1'
                ],
                'item_eyebrow': [
                  'a program for members to earn on every shopping'
                ],
                'item_tag': [
                  'sign in or join now'
                ],
                'tealium_event': 'select_content'
              }
            },
            'unresolvedData': []
          },
          'content': null,
          'clientActionType': null,
          'customHeaders': [
            {
              'key': 'X-ULTA-GRAPH-MODULE-NAME',
              'value': 'SignInOverlay'
            },
            {
              'key': 'X-ULTA-GRAPH-TYPE',
              'value': 'query'
            },
            {
              'key': 'X-ULTA-GRAPH-SUB-TYPE',
              'value': 'page'
            },
            {
              'key': 'X-ULTA-GRAPH-TYPE',
              'value': 'query'
            },
            {
              'key': 'X-ULTA-GRAPH-SUB-TYPE',
              'value': 'page'
            }
          ],
          'clientActionParams': null,
          'method': 'GET',
          'accessibility': null
        },
        'action2': {
          'label': 'Join Now',
          'url': 'https://local.ulta.com:8080/qa/rewards/all?User-Agent=gomez',
          'graphql': null,
          'pop': false,
          'navigationType': 'redirect',
          'anchorId': null,
          'dataCaptureData': {
            'category': 'Interaction',
            'eventName': 'select_content',
            'clientEvent': 'Click',
            'moduleName': 'DataCaptureEvent',
            'dataLayer': {
              'Tealium': {
                'component_click_metric': '1',
                'action_type': 'link',
                'action_label': 'shop now',
                'component_type': 'ultamaterewardsoffers',
                'component_title': 'ulta beauty rewards™ - help changes',
                'item_detail': [
                  'ulta beauty rewards™ - non signed in'
                ],
                'item_index': [
                  '1'
                ],
                'item_eyebrow': [
                  'a program for members to earn on every shopping'
                ],
                'item_tag': [
                  'sign in or join now'
                ],
                'tealium_event': 'select_content'
              }
            },
            'unresolvedData': []
          },
          'content': null,
          'clientActionType': null,
          'customHeaders': [],
          'clientActionParams': null,
          'method': 'GET',
          'accessibility': null
        },
        'action1Style': 'primary',
        'action2Style': 'link',
        'spacerValue': '04',
        'moduleName': 'ActionGroup',
        '_meta': {
          'schema': 'https://qa.ulta.com/cms/schema/ActionGroup.json',
          'name': 'Action Group 1 - Ultamate offers',
          'deliveryId': 'a5269cc8-c8ab-4d14-93c3-e61fd10dd78d'
        }
      },
      'moduleName': 'LargeDeal',
      '_meta': {
        'schema': 'https://qa.ulta.com/cms/schema/LargeDeal.json',
        'name': 'Large Deal - Ultamate rewards non signed in',
        'deliveryId': 'e97caf25-2ed6-428d-9e1e-fcfbbdd8bab7'
      },
      'isOfferActivated': false,
      'offerId': null,
      'offerMasterId': null,
      'activateAction': null,
      'activatedLabel': null
    }, {
      'image': {
        'isCaptionsEnabled': true,
        'action': null,
        'moduleName': 'UltaAsset',
        'isInlineVideo': false,
        'isAutoPlay': false,
        '_meta': {
          'schema': 'http://bigcontent.io/cms/schema/v1/core#/definitions/image-link'
        },
        'imageUrl': 'https://media.ulta.com/i/ulta/beauty-services_20off-promo_april2021_article',
        'id': 'f4fe2f4e-3b08-4082-be2c-3c0d293a2b1f',
        'name': 'beauty-services_20off-promo_april2021_article',
        'endpoint': 'ulta',
        'defaultHost': 'media.ulta.com',
        'metaData': {
          'mediaType': 'image',
          'imageTemplate': 'None',
          'isImage': true,
          'format': 'PNG',
          'width': 852,
          'height': 856,
          'aspectRatio': {
            'w': '1.00',
            'h': 1
          }
        }
      },
      'tag': 'sign in or join now',
      'eyebrow': 'A program for members to earn on every shopping',
      'headline': 'Ulta Beauty Rewards™ - Non signed in',
      'description': 'Earn 5X points on participating youth booster and glow getting products! If copy runs long, it should truncate at 3. BaBylissPRO Nano Titanium Spring Curling Iron combines Sol Gel technology with a titanium/ceramic barrel to transfer heat and deliver smoothing ions.',
      'actionGroup': {
        'action1': {
          'label': 'SIGN IN',
          'url': null,
          'graphql': 'query Page( $stagingHost: String, $previewOptions: JSON, $moduleParams: JSON , $url: JSON) {\n    Page: Page( stagingHost:$stagingHost, previewOptions:$previewOptions, moduleParams:$moduleParams , url: $url, contentId: "2c44d6e2-3b8f-4033-a55d-1bfe210d3498") {\n      content\n      customResponseAttributes\n      meta\n    }\n  }',
          'pop': false,
          'navigationType': 'flyout',
          'anchorId': null,
          'dataCaptureData': {
            'category': 'Interaction',
            'eventName': 'select_content',
            'clientEvent': 'Click',
            'moduleName': 'DataCaptureEvent',
            'dataLayer': {
              'Tealium': {
                'component_click_metric': '1',
                'action_type': 'link',
                'action_label': 'view offer',
                'component_type': 'ultamaterewardsoffers',
                'component_title': 'ulta beauty rewards™ - help changes',
                'item_detail': [
                  'ulta beauty rewards™ - non signed in'
                ],
                'item_index': [
                  '1'
                ],
                'item_eyebrow': [
                  'a program for members to earn on every shopping'
                ],
                'item_tag': [
                  'sign in or join now'
                ],
                'tealium_event': 'select_content'
              }
            },
            'unresolvedData': []
          },
          'content': null,
          'clientActionType': null,
          'customHeaders': [
            {
              'key': 'X-ULTA-GRAPH-MODULE-NAME',
              'value': 'SignInOverlay'
            },
            {
              'key': 'X-ULTA-GRAPH-TYPE',
              'value': 'query'
            },
            {
              'key': 'X-ULTA-GRAPH-SUB-TYPE',
              'value': 'page'
            },
            {
              'key': 'X-ULTA-GRAPH-TYPE',
              'value': 'query'
            },
            {
              'key': 'X-ULTA-GRAPH-SUB-TYPE',
              'value': 'page'
            }
          ],
          'clientActionParams': null,
          'method': 'GET',
          'accessibility': null
        },
        'action2': {
          'label': 'Join Now',
          'url': 'https://local.ulta.com:8080/qa/rewards/all?User-Agent=gomez',
          'graphql': null,
          'pop': false,
          'navigationType': 'redirect',
          'anchorId': null,
          'dataCaptureData': {
            'category': 'Interaction',
            'eventName': 'select_content',
            'clientEvent': 'Click',
            'moduleName': 'DataCaptureEvent',
            'dataLayer': {
              'Tealium': {
                'component_click_metric': '1',
                'action_type': 'link',
                'action_label': 'shop now',
                'component_type': 'ultamaterewardsoffers',
                'component_title': 'ulta beauty rewards™ - help changes',
                'item_detail': [
                  'ulta beauty rewards™ - non signed in'
                ],
                'item_index': [
                  '1'
                ],
                'item_eyebrow': [
                  'a program for members to earn on every shopping'
                ],
                'item_tag': [
                  'sign in or join now'
                ],
                'tealium_event': 'select_content'
              }
            },
            'unresolvedData': []
          },
          'content': null,
          'clientActionType': null,
          'customHeaders': [],
          'clientActionParams': null,
          'method': 'GET',
          'accessibility': null
        },
        'action1Style': 'primary',
        'action2Style': 'link',
        'spacerValue': '04',
        'moduleName': 'ActionGroup',
        '_meta': {
          'schema': 'https://qa.ulta.com/cms/schema/ActionGroup.json',
          'name': 'Action Group 1 - Ultamate offers',
          'deliveryId': 'a5269cc8-c8ab-4d14-93c3-e61fd10dd78d'
        }
      },
      'moduleName': 'LargeDeal',
      '_meta': {
        'schema': 'https://qa.ulta.com/cms/schema/LargeDeal.json',
        'name': 'Large Deal - Ultamate rewards non signed in',
        'deliveryId': 'e97caf25-2ed6-428d-9e1e-fcfbbdd8bab7'
      },
      'isOfferActivated': false,
      'offerId': null,
      'offerMasterId': null,
      'activateAction': null,
      'activatedLabel': null
    }, {
      'image': {
        'isCaptionsEnabled': true,
        'action': null,
        'moduleName': 'UltaAsset',
        'isInlineVideo': false,
        'isAutoPlay': false,
        '_meta': {
          'schema': 'http://bigcontent.io/cms/schema/v1/core#/definitions/image-link'
        },
        'imageUrl': 'https://media.ulta.com/i/ulta/beauty-services_20off-promo_april2021_article',
        'id': 'f4fe2f4e-3b08-4082-be2c-3c0d293a2b1f',
        'name': 'beauty-services_20off-promo_april2021_article',
        'endpoint': 'ulta',
        'defaultHost': 'media.ulta.com',
        'metaData': {
          'mediaType': 'image',
          'imageTemplate': 'None',
          'isImage': true,
          'format': 'PNG',
          'width': 852,
          'height': 856,
          'aspectRatio': {
            'w': '1.00',
            'h': 1
          }
        }
      },
      'tag': 'sign in or join now',
      'eyebrow': 'A program for members to earn on every shopping',
      'headline': 'Ulta Beauty Rewards™ - Non signed in',
      'description': 'Earn 5X points on participating youth booster and glow getting products! If copy runs long, it should truncate at 3. BaBylissPRO Nano Titanium Spring Curling Iron combines Sol Gel technology with a titanium/ceramic barrel to transfer heat and deliver smoothing ions.',
      'actionGroup': {
        'action1': {
          'label': 'SIGN IN',
          'url': null,
          'graphql': 'query Page( $stagingHost: String, $previewOptions: JSON, $moduleParams: JSON , $url: JSON) {\n    Page: Page( stagingHost:$stagingHost, previewOptions:$previewOptions, moduleParams:$moduleParams , url: $url, contentId: "2c44d6e2-3b8f-4033-a55d-1bfe210d3498") {\n      content\n      customResponseAttributes\n      meta\n    }\n  }',
          'pop': false,
          'navigationType': 'flyout',
          'anchorId': null,
          'dataCaptureData': {
            'category': 'Interaction',
            'eventName': 'select_content',
            'clientEvent': 'Click',
            'moduleName': 'DataCaptureEvent',
            'dataLayer': {
              'Tealium': {
                'component_click_metric': '1',
                'action_type': 'link',
                'action_label': 'view offer',
                'component_type': 'ultamaterewardsoffers',
                'component_title': 'ulta beauty rewards™ - help changes',
                'item_detail': [
                  'ulta beauty rewards™ - non signed in'
                ],
                'item_index': [
                  '1'
                ],
                'item_eyebrow': [
                  'a program for members to earn on every shopping'
                ],
                'item_tag': [
                  'sign in or join now'
                ],
                'tealium_event': 'select_content'
              }
            },
            'unresolvedData': []
          },
          'content': null,
          'clientActionType': null,
          'customHeaders': [
            {
              'key': 'X-ULTA-GRAPH-MODULE-NAME',
              'value': 'SignInOverlay'
            },
            {
              'key': 'X-ULTA-GRAPH-TYPE',
              'value': 'query'
            },
            {
              'key': 'X-ULTA-GRAPH-SUB-TYPE',
              'value': 'page'
            },
            {
              'key': 'X-ULTA-GRAPH-TYPE',
              'value': 'query'
            },
            {
              'key': 'X-ULTA-GRAPH-SUB-TYPE',
              'value': 'page'
            }
          ],
          'clientActionParams': null,
          'method': 'GET',
          'accessibility': null
        },
        'action2': {
          'label': 'Join Now',
          'url': 'https://local.ulta.com:8080/qa/rewards/all?User-Agent=gomez',
          'graphql': null,
          'pop': false,
          'navigationType': 'redirect',
          'anchorId': null,
          'dataCaptureData': {
            'category': 'Interaction',
            'eventName': 'select_content',
            'clientEvent': 'Click',
            'moduleName': 'DataCaptureEvent',
            'dataLayer': {
              'Tealium': {
                'component_click_metric': '1',
                'action_type': 'link',
                'action_label': 'shop now',
                'component_type': 'ultamaterewardsoffers',
                'component_title': 'ulta beauty rewards™ - help changes',
                'item_detail': [
                  'ulta beauty rewards™ - non signed in'
                ],
                'item_index': [
                  '1'
                ],
                'item_eyebrow': [
                  'a program for members to earn on every shopping'
                ],
                'item_tag': [
                  'sign in or join now'
                ],
                'tealium_event': 'select_content'
              }
            },
            'unresolvedData': []
          },
          'content': null,
          'clientActionType': null,
          'customHeaders': [],
          'clientActionParams': null,
          'method': 'GET',
          'accessibility': null
        },
        'action1Style': 'primary',
        'action2Style': 'link',
        'spacerValue': '04',
        'moduleName': 'ActionGroup',
        '_meta': {
          'schema': 'https://qa.ulta.com/cms/schema/ActionGroup.json',
          'name': 'Action Group 1 - Ultamate offers',
          'deliveryId': 'a5269cc8-c8ab-4d14-93c3-e61fd10dd78d'
        }
      },
      'moduleName': 'LargeDeal',
      '_meta': {
        'schema': 'https://qa.ulta.com/cms/schema/LargeDeal.json',
        'name': 'Large Deal - Ultamate rewards non signed in',
        'deliveryId': 'e97caf25-2ed6-428d-9e1e-fcfbbdd8bab7'
      },
      'isOfferActivated': false,
      'offerId': null,
      'offerMasterId': null,
      'activateAction': null,
      'activatedLabel': null
    }
  ],
  'hasOffers': false,
  'nextAccessibility': 'Next',
  'previousAccessibility': 'Previous',
  'carouselAccessibility': '%1 Offers Carousel',
  'carouselDetailsAccessibility': 'Use previous and next buttons to navigate the slides of the %1 offers carousel',
  'carouselCardAccessibility': 'Slide %1 of %2'
};
